import { Partial } from '@40seas/entities/common';
import { Underwriting } from './underwriting.entity';

export class UpdateUnderwritingDto extends Partial(Underwriting) {}
